import { render, staticRenderFns } from "./CompanyQuotePanel.vue?vue&type=template&id=323edbb0&scoped=true"
import script from "./CompanyQuotePanel.vue?vue&type=script&lang=js"
export * from "./CompanyQuotePanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyQuotePanel.vue?vue&type=style&index=0&id=323edbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323edbb0",
  null
  
)

export default component.exports